import { Check, X } from "lucide-react";

const Comparison = () => {
  const comparisons = [
    { feature: "Fees", others: "20-30% of your earnings taken", vcm: "0% fees—keep 100% of TikTok Live earnings" },
    { feature: "Contracts", others: "Long-term contracts with penalties for leaving", vcm: "No contracts—leave anytime, no penalties" },
    { feature: "Management Team", others: "Corporate managers who've never created content", vcm: "Active influencers who understand the creator journey" },
    { feature: "Experience", others: "Limited track record with small creators", vcm: "12+ years managing major creators and celebrity-level talent" },
    { feature: "Support", others: "Business hours only, slow response times", vcm: "24/7 VIP support—we're always available" },
    { feature: "Growth Training", others: "Generic tips and outdated strategies", vcm: "Exclusive Rapid Growth Training (1M diamonds in 90 days)" },
    { feature: "Platform Knowledge", others: "Surface-level understanding", vcm: "Close working relationship with TikTok, deep platform expertise" },
    { feature: "Community", others: "Isolated creators competing against each other", vcm: "Elite community of rapid-growth and celebrity-level creators" },
    { feature: "Brand Deals", others: "Limited opportunities, low-paying sponsorships", vcm: "Exclusive access to premium brand partnerships" },
    { feature: "Transparency", others: "Hidden fees, unclear terms", vcm: "100% transparent—no hidden costs, ever" },
  ];

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            The <span className="text-primary">VCM Difference</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Stop getting exploited. See why elite creators choose VCM.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left py-4 px-4 text-muted-foreground font-semibold">Feature</th>
                  <th className="text-center py-4 px-4 text-muted-foreground font-semibold">Other Networks</th>
                  <th className="text-center py-4 px-4 font-semibold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                    VCM
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-border hover:bg-muted/5 transition-colors"
                  >
                    <td className="py-6 px-4 font-medium">{item.feature}</td>
                    <td className="py-6 px-4 text-center">
                      <div className="flex items-center justify-center space-x-2">
                        <X className="text-destructive" size={20} />
                        <span className="text-muted-foreground">{item.others}</span>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center">
                      <div className="flex items-center justify-center space-x-2">
                        <Check className="text-accent" size={20} />
                        <span className="text-primary font-semibold">{item.vcm}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-12 p-8 rounded-2xl bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/20">
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-3">Calculate Your Savings</h3>
              <p className="text-muted-foreground mb-6">
                If you earn $100,000 in diamonds per year:
              </p>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="p-6 rounded-xl bg-destructive/10 border border-destructive/20">
                  <div className="text-sm text-muted-foreground mb-2">Other Networks (25% fee)</div>
                  <div className="text-3xl font-bold text-destructive">$75,000</div>
                  <div className="text-sm text-muted-foreground mt-2">You keep</div>
                </div>
                <div className="p-6 rounded-xl bg-accent/10 border border-accent/20">
                  <div className="text-sm text-muted-foreground mb-2">VCM (0% fee)</div>
                  <div className="text-3xl font-bold text-accent">$100,000</div>
                  <div className="text-sm text-muted-foreground mt-2">You keep</div>
                </div>
              </div>
              <div className="mt-6 text-xl font-bold">
                That's <span className="text-secondary">$25,000 more</span> in your pocket
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
